import React from "react";
import Form from 'react-bootstrap/Form';
import DatePicker from '../DatePicker';
import BotonGeneralRight from "../elementos/BotonGeneralRight";
import Tabla from "../elementos/Tabla";
import Container from 'react-bootstrap/Container';
import { InputGroup } from "react-bootstrap";




import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';






function Carga() {

    return(
        
        <> 
        
            <Container>
                <div className="Titulos-posicion">
                     <h1>Cargar menu</h1>
                </div>    
            <div className="Tabla-carga-absolute">    
                <div  className="animated bounceInLeft">
                                                            
                     <InputGroup className="mb-4">
                        
                        <DatePicker /> 
                        
                     </InputGroup> 
                <br />
                     <Form.Select size="lg">
                        <option>Menú general</option>
                    </Form.Select>
                <br />
                <div>    
                    <Form.Select size="lg">
                        <option>Menú Vegetariano</option>
                    </Form.Select>
                </div>
                <br />
                <div>    
                    <Form.Select size="lg">
                        <option>Menú Light</option>
                    </Form.Select>
                <br />
                </div>        
                                
                    <BotonGeneralRight/>
                        
                </div>  
          </div>                      
                        
            <div className="Tabla-absolute" >
                <section className='animated bounceInRight'>
                    <Tabla/>
                </section>  
                        
            </div>  
            </Container>        
                     
          
        </>
       
    );

}

export default Carga;